import { ResourceCategoryBase } from './base/resource-category-base';

export class ResourceCategory extends ResourceCategoryBase { }